import React from "react"

const SkillTags = props => {
  	const consultant = props.consultant
  	console.log(consultant)
  	return (
	  	<div>
			{
				consultant.expertise.split(',').map ( ( expertiseItem, index ) => 
					<div key={index} className="label__keywords_new skill-tag">
						{expertiseItem}
					</div>
				) 
			}
		</div>
	)	
};
export default SkillTags